"use client";
import React from "react";
import { default as MuiGrid } from "@mui/material/Grid";
import { GridProps as MuiGridProps } from "@mui/material/Grid";
/**
 * @deprecated These props are now not used anymore since the grid 2 props became grid 1 props after the mui upgrade they do the same but we prefer using just components without numbers in them.
 */
export type WcGrid2Props = MuiGridProps;
/**
 * @deprecated This is now not used anymore since the grid 2 became grid 1 after the mui upgrade they do the same but we prefer using just components without numbers in them.
 */
export const WcGrid2 = (props: WcGrid2Props) => <MuiGrid {...props}></MuiGrid>;
